import React, { useEffect, useRef, useState } from 'react';
import constMap from '../../const/const';
import { isEmpty, isNotEmpty, isUndefined, stringToDate } from '../../util/util';
import DatetimePicker from './DatetimePicker';
import IsdTextBox from './isdTextBox';
import { observer, useLocalStore } from "mobx-react";
import { configure } from 'mobx';
let openCalendar = false;
const IsdTextboxYmd = observer(React.forwardRef((props, ref) => {
    configure({
        enforceActions: 'never',
    })
    const [isOpenContainer, setIsOpenContainer] = useState(false);
    ref = {
        textInput: useRef(null),
        datePicker: useRef(null)
    }

    const state = useLocalStore(() => ({
        spanWidth: 'w95',
        textWidth: 'w80',
        maxlength: '',
        ymdWidth: '',
        formatString: 'yyyy/MM/dd'
    }))

    useEffect(() => {
        switch (props.format) {
            case constMap.format.yyyymm:
                state.formatString = 'YYYY/MM';
                break;
            case constMap.format.yyyymmdd:
                state.formatString = "YYYY/MM/DD";
                break;
            default:
        }
        if (isNotEmpty(props.className)) {
            // classの中からwidthの設定を取り出す
            props.className.split(" ").forEach((val) => {
                // w0～w999までの範囲
                if (/^w[0-9]{0,3}$/.test(val)) {
                    state.ymdWidth = val.replace("w", "");
                    return false;
                }
            })
        }
        switch (props.format) {
            case constMap.format.yyyymm:
                state.spanWidth = isEmpty(state.ymdWidth) ? 80 : +(state.ymdWidth);
                state.textWidth = state.spanWidth - 10;
                state.maxlength = "7";
                break;
            case constMap.format.yyyymmdd:
                state.spanWidth = isEmpty(state.ymdWidth) ? 105 : +(state.ymdWidth);
                state.textWidth = state.spanWidth - 10;
                state.maxlength = "10";
                break;
            default:
        }
        if (isNotEmpty(state.spanWidth)) state.spanWidth = "w" + state.spanWidth;
        if (isNotEmpty(state.textWidth)) state.textWidth = "w" + state.textWidth;
        ref.textInput.current.element.focus();
        document.body.addEventListener('mousedown', (event) => {
            if (event.srcElement && event.srcElement.classList) {
                if ([`ymd-btn-${props.name}`].some(c => [...event.srcElement.classList].includes(c))) {
                    openCalendar = true;
                    return;
                }
            }
        });
    }, []);

    //入力変更時に実行されるイベント
    const handleInputChange = (event) => {
        if (!isUndefined(props.onChange)) props.onChange(event);
    };

    const onFocus = (event) => {
        setIsOpenContainer(false);
        openCalendar = false;
        if (props.onFocus) props.onFocus(event);
    }
    const onBlur = (event) => {
        if (openCalendar) {
            openCalendar = false;
            return;
        }
        if (props.onBlur) props.onBlur(event);

        if (!event.target.value) return;
        if (stringToDate(event.target.value)) {
            ref.datePicker.current.checkDate(stringToDate(event.target.value));
        }
    }
    return (<>
        <span className={'input-group dateform ' + state.spanWidth}>
            <IsdTextBox ctrlproptype="date" format={state.formatString} required={props.required}
                disabled={props.disabled} id={props.name}
                name={props.name}
                value={props.value}
                ref={ref.textInput} isdmaxlength={state.maxlength}
                className={state.textWidth} onFocus={onFocus}
                onChange={handleInputChange} onBlur={onBlur}
            />
            <DatetimePicker disabled={props.disabled}
                isCheckPastDay={props.isCheckPastDay}
                isCheckPastMonday={props.isCheckPastMonday}
                isOpenContainer={isOpenContainer}
                name={props.name}
                ref={ref.datePicker}
                className={props.className}
                input={ref.textInput.current && ref.textInput.current.element}
                formatString={state.formatString}
                dataGrid={props.dataGrid}
                handleInputChange={handleInputChange}></DatetimePicker>
        </span>
    </>);
}))
export default IsdTextboxYmd;